<template>
  <header>
    <gnb />
  </header>
</template>

<script>
import Gnb from '@/components/layout/header/Gnb'
export default {
  components: {
    Gnb
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
     handleScroll(e) {
       // 좌우 스크롤 이동에 따른 헤더 포지션 변경
      let header = document.querySelector('.navigator')
      header.style.left = `-${window.scrollX | document.documentElement.scrollLeft}px`
     }
  }
}
</script>

<style>

</style>